import { Selector } from '@ngxs/store';
import { BotState, BotStateModel } from './bot.state';

export class BotSelectors {
  @Selector([BotState])
  static botTeam(state: BotStateModel): any {
    return state.team;
  }
  @Selector([BotState])
  static botConnections(state: BotStateModel): any[] | undefined {
    return state.connections;
  }
  @Selector([BotState])
  static scenarios(state: BotStateModel): any[] {
    return state.scenarios;
  }

  @Selector([BotState])
  static botId(state: BotStateModel): string | undefined {
    return state.botId;
  }

  @Selector([BotState])
  static categories(state: BotStateModel): Array<any> {
    return state.categories;
  }
}
